import { InvestigatorNotificationUpdateDto, SiteEmployeeDto } from 'common/api';

export function getManualReferralEligibleAssignments(
  assignments: InvestigatorNotificationUpdateDto[] = [],
  user?: SiteEmployeeDto | null
) {
  const investigatorAssignmentIds = new Set(
    (user?.investigators || []).map((investigator) => investigator.id)
  );

  return assignments.filter(
    (assignment) =>
      investigatorAssignmentIds.has(assignment.id) &&
      Boolean(assignment.studyLanguage?.trim())
  );
}
